module.exports = __webpack_public_path__ + "static/img/what2.32157ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/what2.png
// module id = zjn9
// module chunks = 0